import React from "react";
import Checkbox from "./Checkbox";
import styles from "./Attachment.css";

const Attachment = function ({ attachment }) {
    const link = attachment.link ? (
        <a href={attachment.link} target="_blank">
            {attachment.label}
        </a>
    ) : (
        attachment.label
    );

    return (
        <div className={styles.Attachment}>
            {(attachment.required && <Checkbox required>{link}</Checkbox>) || (
                <span className={styles.AttachmentLink}>{link}</span>
            )}
        </div>
    );
};

export default Attachment;
